import banner_1 from '../../assets/images/simCard/banner_1.png'
import banner_2 from '../../assets/images/simCard/banner_2.png'



export const banners =[
    {
        id:1,
        title:'lorem',
        url: banner_1
    },
    {
        id:2,
        title:'lorem',
        url:banner_2
    }
]
export const sliders = [
    {
        id:1,
        title: 'Lorem',
        linkTo:'/nap-tien-tuc-thi',
        url:'https://cdn.tgdd.vn/2022/07/banner/800x170-100-800x170-1.jpg'
    },
    {
        id:2,
        title: 'Lorem',
        linkTo:'/sim-so-dep',
        url:'https://cdn.tgdd.vn/2022/08/banner/800X170-800x170.jpg'
    
    },
    {
        id:3,
        title: 'Lorem',
        linkTo:'/big-data',
        url:'https://cdn.tgdd.vn/2022/06/banner/esim-desktop-800x1701-800x170.jpg'
    
    },
    {
        id:4,
        title: 'Lorem',
        linkTo:'/bong-da-ngoai-hang-anh',
        url:'https://cdn.tgdd.vn/2022/06/banner/800x170-800x170-3.jpg'
    
    },
    {
        id:5,
        title: 'Lorem',
        linkTo:'/truyen-h',
        url:'https://cdn.tgdd.vn/2021/05/banner/Die%CC%82%CC%89mna%CC%A3p-die%CC%82%CC%89mru%CC%81tMOMOweb-800-800x170.png'
    
    },
    {
        id:6,
        title: 'Lorem',
        linkTo:'/nap-rut-momo',
        url:'https://cdn.tgdd.vn/2021/12/banner/800-170-800x170-3.png'
    
    },
   
]

export const list_card_data=[
    {
        id:1,
        brand:'vina',
        title:'Vina Bùm 24h 3T',
        service:[
            {
                icon:'icon-data',
                content:'100GB/Tháng',
            }
        ],
        info:['MIỄN PHÍ 03 THÁNG ĐẦU.','Sau 03 tháng: 135.000đ/3 tháng tiếp theo.'],
        price:'300.000',
        link:'sim-so-dep/vinaphone',
        img:'https://cdn.tgdd.vn/2022/07/simpackages/desk-vina-124x182.png'
    },
    {
        id:2,
        brand:'viettel',
        title:'Vina Bùm 24h 3T',
        service:[
            {
                icon:'icon-data',
                content:'4GB Data/Ngày',
            },
            {
                icon:'icon-call',
                content:'Miễn phí cuộc gọi nội mạng',
            },
            {
                icon:'icon-call',
                content:'50 Phút/Tháng',
            },
        ],
        info:['MIỄN PHÍ 03 THÁNG ĐẦU.','Sau 03 tháng: 135.000đ/3 tháng tiếp theo.'],
        price:'300.000',
        link:'sim-so-dep/vinaphone',
        img:'https://cdn.tgdd.vn/2022/05/simpackages/desk-viettel2-124x182.png'
    },
    {
        id:3,
        brand:'mobi',
        title:'Vina Bùm 24h 3T',
        service:[
            {
                icon:'icon-data',
                content:'4GB Data/Ngày',
            },
            {
                icon:'icon-call',
                content:'Miễn phí cuộc gọi nội mạng',
            },
            {
                icon:'icon-call',
                content:'50 Phút/Tháng',
            },
        ],
        info:['MIỄN PHÍ 03 THÁNG ĐẦU.','Sau 03 tháng: 135.000đ/3 tháng tiếp theo.'],
        price:'300.000',
        link:'sim-so-dep/vinaphone',
        img:'https://cdn.tgdd.vn/2022/07/simpackages/desk-vina-124x182.png'
    },
    {
        id:4,
        brand:'mobi',
        title:'Vina Bùm 24h 3T',
        service:[
            {
                icon:'icon-data',
                content:'4GB Data/Ngày',
            },
            {
                icon:'icon-call',
                content:'Miễn phí cuộc gọi nội mạng',
            },
            {
                icon:'icon-call',
                content:'50 Phút/Tháng',
            },
        ],
        info:['MIỄN PHÍ 03 THÁNG ĐẦU.','Sau 03 tháng: 135.000đ/3 tháng tiếp theo.'],
        price:'300.000',
        link:'sim-so-dep/vinaphone',
        img:'https://cdn.tgdd.vn/2022/07/simpackages/desk-vina-124x182.png'
    },
    {
        id:5,
        brand:'mobi',
        title:'Vina Bùm 24h 3T',
        service:[
            {
                icon:'icon-data',
                content:'4GB Data/Ngày',
            },
            {
                icon:'icon-call',
                content:'Miễn phí cuộc gọi nội mạng',
            },
            {
                icon:'icon-call',
                content:'50 Phút/Tháng',
            },
        ],
        info:['MIỄN PHÍ 03 THÁNG ĐẦU.','Sau 03 tháng: 135.000đ/3 tháng tiếp theo.'],
        price:'300.000',
        img:'https://cdn.tgdd.vn/2022/07/simpackages/desk-vina-124x182.png'
    },
    {
        id:6,
        brand:'mobi',
        title:'Vina Bùm 24h 3T',
        service:[
            {
                icon:'icon-data',
                content:'4GB Data/Ngày',
            },
            {
                icon:'icon-call',
                content:'Miễn phí cuộc gọi nội mạng',
            },
            {
                icon:'icon-call',
                content:'50 Phút/Tháng',
            },
        ],
        info:['MIỄN PHÍ 03 THÁNG ĐẦU.','Sau 03 tháng: 135.000đ/3 tháng tiếp theo.'],
        price:'300.000',
        link:'sim-so-dep/vinaphone',
        img:'https://cdn.tgdd.vn/2022/07/simpackages/desk-vina-124x182.png'
    },
    {
        id:7,
        brand:'mobi',
        title:'Vina Bùm 24h 3T',
        service:[
            {
                icon:'icon-data',
                content:'4GB Data/Ngày',
            },
            {
                icon:'icon-call',
                content:'Miễn phí cuộc gọi nội mạng',
            },
            {
                icon:'icon-call',
                content:'50 Phút/Tháng',
            },
        ],
        info:['MIỄN PHÍ 03 THÁNG ĐẦU.','Sau 03 tháng: 135.000đ/3 tháng tiếp theo.'],
        price:'300.000',
        link:'sim-so-dep/vinaphone',
        img:'https://cdn.tgdd.vn/2022/07/simpackages/desk-vina-124x182.png'
    },
    {
        id:8,
        brand:'mobi',
        title:'Vina Bùm 24h 3T',
        service:[
            {
                icon:'icon-data',
                content:'4GB Data/Ngày',
            },
            {
                icon:'icon-call',
                content:'Miễn phí cuộc gọi nội mạng',
            },
            {
                icon:'icon-call',
                content:'50 Phút/Tháng',
            },
        ],
        info:['MIỄN PHÍ 03 THÁNG ĐẦU.','Sau 03 tháng: 135.000đ/3 tháng tiếp theo.'],
        price:'300.000',
        link:'sim-so-dep/vinaphone',
        img:'https://cdn.tgdd.vn/2022/07/simpackages/desk-vina-124x182.png'
    },
    {
        id:9,
        brand:'mobi',
        title:'Vina Bùm 24h 3T',
        service:[
            {
                icon:'icon-data',
                content:'4GB Data/Ngày',
            },
            {
                icon:'icon-call',
                content:'Miễn phí cuộc gọi nội mạng',
            },
            {
                icon:'icon-call',
                content:'50 Phút/Tháng',
            },
        ],
        info:['MIỄN PHÍ 03 THÁNG ĐẦU.','Sau 03 tháng: 135.000đ/3 tháng tiếp theo.'],
        price:'300.000',
        img:'https://cdn.tgdd.vn/2022/07/simpackages/desk-vina-124x182.png'
    },
    {
        id:10,
        brand:'mobi',
        title:'Vina Bùm 24h 3T',
        service:[
            {
                icon:'icon-data',
                content:'4GB Data/Ngày',
            },
            {
                icon:'icon-call',
                content:'Miễn phí cuộc gọi nội mạng',
            },
            {
                icon:'icon-call',
                content:'50 Phút/Tháng',
            },
        ],
        info:['MIỄN PHÍ 03 THÁNG ĐẦU.','Sau 03 tháng: 135.000đ/3 tháng tiếp theo.'],
        price:'300.000',
        link:'sim-so-dep/vinaphone',
        img:'https://cdn.tgdd.vn/2022/07/simpackages/desk-vina-124x182.png'
    },
    {
        id:11,
        brand:'mobi',
        title:'Vina Bùm 24h 3T',
        service:[
            {
                icon:'icon-data',
                content:'4GB Data/Ngày',
            },
            {
                icon:'icon-call',
                content:'Miễn phí cuộc gọi nội mạng',
            },
            {
                icon:'icon-call',
                content:'50 Phút/Tháng',
            },
        ],
        info:['MIỄN PHÍ 03 THÁNG ĐẦU.','Sau 03 tháng: 135.000đ/3 tháng tiếp theo.'],
        price:'300.000',
        link:'sim-so-dep/vinaphone',
        img:'https://cdn.tgdd.vn/2022/07/simpackages/desk-vina-124x182.png'
    },
    {
        id:12,
        brand:'mobi',
        title:'Vina Bùm 24h 3T',
        service:[
            {
                icon:'icon-data',
                content:'4GB Data/Ngày',
            },
            {
                icon:'icon-call',
                content:'Miễn phí cuộc gọi nội mạng',
            },
            {
                icon:'icon-call',
                content:'50 Phút/Tháng',
            },
        ],
        info:['MIỄN PHÍ 03 THÁNG ĐẦU.','Sau 03 tháng: 135.000đ/3 tháng tiếp theo.'],
        price:'300.000',
        link:'sim-so-dep/vinaphone',
        img:'https://cdn.tgdd.vn/2022/07/simpackages/desk-vina-124x182.png'
    },
    {
        id:13,
        brand:'mobi',
        title:'Vina Bùm 24h 3T',
        service:[
            {
                icon:'icon-data',
                content:'4GB Data/Ngày',
            },
            {
                icon:'icon-call',
                content:'Miễn phí cuộc gọi nội mạng',
            },
            {
                icon:'icon-call',
                content:'50 Phút/Tháng',
            },
        ],
        info:['MIỄN PHÍ 03 THÁNG ĐẦU.','Sau 03 tháng: 135.000đ/3 tháng tiếp theo.'],
        price:'300.000',
        link:'sim-so-dep/vinaphone',
        img:'https://cdn.tgdd.vn/2022/07/simpackages/desk-vina-124x182.png'
    },
    {
        id:14,
        brand:'mobi',
        title:'Vina Bùm 24h 3T',
        service:[
            {
                icon:'icon-data',
                content:'4GB Data/Ngày',
            },
            {
                icon:'icon-call',
                content:'Miễn phí cuộc gọi nội mạng',
            },
            {
                icon:'icon-call',
                content:'50 Phút/Tháng',
            },
        ],
        info:['MIỄN PHÍ 03 THÁNG ĐẦU.','Sau 03 tháng: 135.000đ/3 tháng tiếp theo.'],
        price:'300.000',
        link:'sim-so-dep/vinaphone',
        img:'https://cdn.tgdd.vn/2022/07/simpackages/desk-vina-124x182.png'
    },
    {
        id:15,
        brand:'mobi',
        title:'Vina Bùm 24h 3T',
        service:[
            {
                icon:'icon-data',
                content:'4GB Data/Ngày',
            },
            {
                icon:'icon-call',
                content:'Miễn phí cuộc gọi nội mạng',
            },
            {
                icon:'icon-call',
                content:'50 Phút/Tháng',
            },
        ],
        info:['MIỄN PHÍ 03 THÁNG ĐẦU.','Sau 03 tháng: 135.000đ/3 tháng tiếp theo.'],
        price:'300.000',
        link:'sim-so-dep/vinaphone',
        img:'https://cdn.tgdd.vn/2022/07/simpackages/desk-vina-124x182.png'
    },
    {
        id:16,
        brand:'mobi',
        title:'Vina Bùm 24h 3T',
        service:[
            {
                icon:'icon-data',
                content:'4GB Data/Ngày',
            },
            {
                icon:'icon-call',
                content:'Miễn phí cuộc gọi nội mạng',
            },
            {
                icon:'icon-call',
                content:'50 Phút/Tháng',
            },
        ],
        info:['MIỄN PHÍ 03 THÁNG ĐẦU.','Sau 03 tháng: 135.000đ/3 tháng tiếp theo.'],
        price:'300.000',
        link:'sim-so-dep/vinaphone',
        img:'https://cdn.tgdd.vn/2022/07/simpackages/desk-vina-124x182.png'
    },
    {
        id:17,
        brand:'mobi',
        title:'Vina Bùm 24h 3T',
        service:[
            {
                icon:'icon-data',
                content:'4GB Data/Ngày',
            },
            {
                icon:'icon-call',
                content:'Miễn phí cuộc gọi nội mạng',
            },
            {
                icon:'icon-call',
                content:'50 Phút/Tháng',
            },
        ],
        info:['MIỄN PHÍ 03 THÁNG ĐẦU.','Sau 03 tháng: 135.000đ/3 tháng tiếp theo.'],
        price:'300.000',
        link:'sim-so-dep/vinaphone',
        img:'https://cdn.tgdd.vn/2022/07/simpackages/desk-vina-124x182.png'
    },
]

export const list_basic_sim = [
    {
        id:1,
        brand:'vina',
        price:'300.000',
        img:'https://cdn.tgdd.vn/2022/08/simpackages/desk-vina-small-260x55-3.png'
    },
    {
        id:2,
        brand:'mobi',
        price:'300.000',
        img:'https://cdn.tgdd.vn/2022/08/simpackages/desk-vina-small-260x55-3.png'
    },
    {
        id:3,
        brand:'itel',
        price:'300.000',
        img:'https://cdn.tgdd.vn/2022/08/simpackages/desk-vina-small-260x55-3.png'
    },
]

export const list_number_sim =[
    {
        id:1,
        phoneNumber:'0838.416.801',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:2,
        phoneNumber:'0838.416.802',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:3,
        phoneNumber:'0838.416.803',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:4,
        phoneNumber:'0838.416.804',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:5,
        phoneNumber:'0838.416.805',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:6,
        phoneNumber:'0838.416.806',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:7,
        phoneNumber:'0838.416.807',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:8,
        phoneNumber:'0838.416.808',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:9,
        phoneNumber:'0838.416.809',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:10,
        phoneNumber:'0838.416.810',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:11,
        phoneNumber:'0838.416.811',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:12,
        phoneNumber:'0838.416.812',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:13,
        phoneNumber:'0838.416.813',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:14,
        phoneNumber:'0838.416.814',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:15,
        phoneNumber:'0838.416.815',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:16,
        phoneNumber:'0838.416.816',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:17,
        phoneNumber:'0838.416.817',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:18,
        phoneNumber:'0838.416.818',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:19,
        phoneNumber:'0838.416.819',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:20,
        phoneNumber:'0838.416.820',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:21,
        phoneNumber:'0838.416.821',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:22,
        phoneNumber:'0812.222.922',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:23,
        phoneNumber:'0812.222.923',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:24,
        phoneNumber:'0812.222.924',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:25,
        phoneNumber:'0812.222.925',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:26,
        phoneNumber:'0812.222.926',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:27,
        phoneNumber:'0812.222.927',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:28,
        phoneNumber:'0812.222.928',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:229,
        phoneNumber:'0812.222.929',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:29,
        phoneNumber:'0812.222.930',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:30,
        phoneNumber:'0812.222.931',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:31,
        phoneNumber:'0812.222.932',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:32,
        phoneNumber:'0812.222.933',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:33,
        phoneNumber:'0812.222.934',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:34,
        phoneNumber:'0812.222.935',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:35,
        phoneNumber:'0812.222.936',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:36,
        phoneNumber:'0812.222.937',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:37,
        phoneNumber:'0812.222.938',
        price:'300.000',
        brand:'Vinaphone',
    },
    {
        id:38,
        phoneNumber:'0812.222.939',
        price:'300.000',
        brand:'Vinaphone',
    },
]

export const menu_drop_down_classify =['Số tiền','Năm sinh','Lặp - Kép','Thần tài','Phát Lộc','Tứ Quý giữa','Ông Địa','Tam Hoa','Bình dân']


export const list_suppliers = [
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2020/09/content/ArtboardCopy51x-130x48.png'
    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2020/09/content/ArtboardCopy51x-130x48.png'
    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2020/09/content/ArtboardCopy51x-130x48.png'
    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2020/09/content/ArtboardCopy51x-130x48.png'
    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2020/09/content/ArtboardCopy51x-130x48.png'
    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2020/09/content/ArtboardCopy51x-130x48.png'
    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2020/09/content/ArtboardCopy51x-130x48.png'
    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2020/09/content/ArtboardCopy51x-130x48.png'
    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2020/09/content/ArtboardCopy51x-130x48.png'
    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2020/09/content/ArtboardCopy51x-130x48.png'
    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2020/09/content/ArtboardCopy51x-130x48.png'
    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2020/09/content/ArtboardCopy51x-130x48.png'
    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2020/09/content/ArtboardCopy51x-130x48.png'
    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2020/09/content/ArtboardCopy51x-130x48.png'
    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2020/09/content/ArtboardCopy51x-130x48.png'
    }
]

export const list_card_price = [
    '50.000','100.000','200.000','300.000','500.000','1.000.000'
]

export const list_net_work =[
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2021/01/content/LogoViettelred-300x79.png'
    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2021/01/content/LogoViettelred-300x79.png'
    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2021/01/content/LogoViettelred-300x79.png'
    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2021/01/content/LogoViettelred-300x79.png'
    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2021/01/content/LogoViettelred-300x79.png'
    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2021/01/content/LogoViettelred-300x79.png'
    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2021/01/content/LogoViettelred-300x79.png'
    },
    {
        id: 1,
        url: 'https://cdn.tgdd.vn/2021/01/content/LogoViettelred-300x79.png'
    }
]